import React from 'react';
import ReactDOM from 'react-dom/client'; // Import the new createRoot API
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx'; // Ensure the correct extension is used
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';

// Create the root using React 18's createRoot API
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the application
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);